import type { RecursivePartial } from '#root/types/utils.js'
import type { PdpConfig } from '#types/config/components/pdp'

export default {
  drawer: {
    minHeight: 280
  }
} satisfies RecursivePartial<PdpConfig['layout']>
